
export class ScratchModel {
  id: number;
  id_hash: string;
  number: string;
  campaignImage: string;
  scratchImage: string;
  sequence: number;
  status: number;
  scratched: Date;
  acquisition: string;
  gift: any;
  contemplated: boolean;
  instructionText: string;
}


export enum ScratchStatus {
  EMITED = 1,
  VIZUALIZED = 2,
  SCRATCHING = 3,
  SCRATCHED = 4,
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/models/scratch.model.ts